import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  Rectangle,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { checkAuthenticated } from "../actions/auth";
import { load_annual_summary } from "../actions/payment_management";
import { useEffect } from "react";
import CalendarYearSelect from "../components/Calendar/CalendarYearSelect";

const month_data = [
  {
    name: "Enero",
    ingresos: null,
    egresos: null,
  },
  {
    name: "Febrero",
    ingresos: null,
    egresos: null,
  },
  {
    name: "Marzo",
    ingresos: null,
    egresos: null,
  },
  {
    name: "Abril",
    ingresos: null,
    egresos: null,
  },
  {
    name: "Mayo",
    ingresos: null,
    egresos: null,
  },
  {
    name: "Junio",
    ingresos: null,
    egresos: null,
  },
  {
    name: "Julio",
    ingresos: null,
    egresos: null,
  },
  {
    name: "Agosto",
    ingresos: null,
    egresos: null,
  },
  {
    name: "Septiembre",
    ingresos: null,
    egresos: null,
  },
  {
    name: "Octubre",
    ingresos: null,
    egresos: null,
  },
  {
    name: "Noviembre",
    ingresos: null,
    egresos: null,
  },
  {
    name: "Diciembre",
    ingresos: null,
    egresos: null,
  },
];
const active_data = [
  {
    name: "Servicios",
    Ingreso: null,
    Egreso: null,
  },
  {
    name: "Productos",
    Ingreso: null,
    Egreso: null,
  },
  {
    name: "Arriendos",
    Ingreso: null,
    Egreso: null,
  },
  {
    name: "Banco",
    Ingreso: null,
    Egreso: null,
  },
  {
    name: "Remuner.",
    Ingreso: null,
    Egreso: null,
  },
  {
    name: "Otros",
    Ingreso: null,
    Egreso: null,
  },
];

const FinanceAnnualSummaryCharts = () => {
  const dispatch = useDispatch();

  const nowDate = new Date();
  const [summaryYear, setSummaryYear] = useState(nowDate.getFullYear());
  const [annualSummary, setAnnualSummary] = useState({
    by_month: month_data,
    by_active_type: active_data,
  });

  const fetchAnnualSummary = async () => {
    dispatch(checkAuthenticated());

    const data = await load_annual_summary({
      year: summaryYear,
    });
    if (data) {
      setAnnualSummary(data);
    }
  };

  const changeSummaryYear = (year, month) => {
    setSummaryYear(parseInt(year));
  };

  useEffect(() => {
    fetchAnnualSummary();
  }, [summaryYear]);
  return (
    <div className="summary-charts ">
      <div className="summary-header d-flex align-items-center gap-2">
        <h4>Resumen Anual</h4>
        <div>
          <CalendarYearSelect
            dateValues={{ year: summaryYear, month: 1 }}
            changeCalendarDate={changeSummaryYear}
          />
        </div>
      </div>
      <div className="summary-content row">
        <div className="fin-chart col-12 col-xl-6 out-vs-in-chart">
          <div className="chart-header d-flex align-items-center gap-2">
            <h4>Ingresos vs Egresos</h4>
          </div>
          <div>
            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={annualSummary.by_month}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="name"
                  angle={-55}
                  textAnchor="end"
                  height={75}
                />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="ingresos" stroke="#1F7EE8" dot={{ r: 4 }} activeDot={{ r: 6 }}  />
                <Line type="monotone" dataKey="egresos" stroke="#F44336" dot={{ r: 4 }} activeDot={{ r: 6 }}  />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="fin-chart col-12 col-lg-6 col-xl-6 active-in-chart">
          <div className="chart-header">
            <h4>Ingresos por Tipo</h4>
          </div>
          <div>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart
                width={500}
                height={300}
                data={annualSummary.by_active_type}
                layout="vertical"
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" />
                <YAxis
                  type="category"
                  dataKey="name"
                  width={75}
                  // angle={22.5}
                  textAnchor="end"
                />
                <Tooltip />
                <Bar
                  dataKey="Ingreso"
                  fill="#1F7EE8"
                  activeBar={<Rectangle fill="#1F7EE8" stroke="#4CAF50" />}
                />
                <Bar
                  dataKey="Egreso"
                  fill="#02C39A"
                  activeBar={<Rectangle fill="#02C39A" stroke="purple" />}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinanceAnnualSummaryCharts;
